import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import { GridFailed, GridSuccess } from 'src/app/shared/actions/grid.actions';
import {
  ChangeSidenavStatus,
  OpenConfirmDialogForDeactivateStatus,
  OpenConfirmDialogForDeleteRow,
} from '../actions/integration-management-actions.actions';

export interface IntegrationManagementActionsState {
  showDeleteRowConfirmText: boolean;
  showDeactivateStatusRowConfirmText: boolean;
  selectedIntegrationCode: string;
  selectedIntegrationRowData: any;
  openedSidenav: boolean;
}

const initialState: IntegrationManagementActionsState = {
  showDeleteRowConfirmText: false,
  showDeactivateStatusRowConfirmText: false,
  selectedIntegrationCode: '',
  selectedIntegrationRowData: [],
  openedSidenav: false,
};

export const IntegrationManagementActionsReducer = createReducer(
  initialState,
  on(OpenConfirmDialogForDeleteRow, (state) => ({
    ...state,
    showDeleteRowConfirmText: true,
    showDeactivateStatusRowConfirmText: false,
  })),
  on(OpenConfirmDialogForDeactivateStatus, (state) => ({
    ...state,
    showDeleteRowConfirmText: false,
    showDeactivateStatusRowConfirmText: true,
  })),
  on(GridSuccess, (state) => ({
    ...state,
    showDeleteRowConfirmText: false,
    showDeactivateStatusRowConfirmText: false,
    selectedIntegrationCode: '',
    selectedIntegrationRowData: [],
    openedSidenav: state.openedSidenav,
  })),
  on(GridFailed, (state) => ({
    ...state,
    showDeleteRowConfirmText: false,
    showDeactivateStatusRowConfirmText: false,
    selectedIntegrationCode: '',
    selectedIntegrationRowData: [],
    openedSidenav: state.openedSidenav,
  })),
  on(ChangeSidenavStatus, (state) => ({
    ...state,
    openedSidenav: !state.openedSidenav,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    openedSidenav: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
